<template>
  <div>
    <el-dropdown trigger="click" placement="bottom-start" v-show="permission && permission.edit" @visible-change="loadList()">
      <el-button type="primary" size="small" icon="el-icon-right">
        移動
        <font-awesome-icon icon="caret-down" style="margin-left:5px" />
      </el-button>
      <el-dropdown-menu slot="dropdown" class="list-select">
        <div class="dropdown-search">
          <el-input class="dropdown-input" placeholder="リストを検索" prefix-icon="el-icon-search" size="large" clearable v-model="search_word" @input="loadList()"></el-input>
        </div>
        <el-dropdown-item class="add-list-dropdown" @click.native="openConfirmModal(list.list_id, list.list_name)" v-for="list in this.list" :key="list.id" v-show="list.list_id != list_id">
          <div class="flex-row">
            <font-awesome-icon :icon="['fab', list.sns_type]" style="margin-right:5px" />
            <div class="dropdown_listname">{{ list.list_name }}</div>
            <div class="flex-space"></div>
            <span>{{ list.influencer_num }}</span>
          </div>
        </el-dropdown-item>
        <div v-show="result_count == 0 && !loading" class="add-list-dropdown-nolist">リストがありません</div>
        <infinite-loading spinner="spiral" :identifier="infiniteId" @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results" style="font-size:40px;"></div>
        </infinite-loading>
        <div style="padding-bottom: 10px"></div>
      </el-dropdown-menu>
    </el-dropdown>

    <el-button type="primary" size="small" icon="el-icon-right" v-show="permission && !permission.edit" @click="openUnpermitted()">
      移動
      <font-awesome-icon icon="caret-down" style="margin-left:5px" />
    </el-button>

    <transition name="fade">
      <div class="phrase-overlay" v-if="confirm" @click.self="closeConfirm()">
        <div class="create-phrase-wrap w-480">
          <div class="list-create">
            <div class="newmessage-title">
              インフルエンサーを移動
              <div class="flex-space"></div>
              <div class="newmessage-button" @click="closeConfirm()">
                <font-awesome-icon :icon="['fal', 'times']" />
              </div>
            </div>
            <div class="list-create-message">
              <div><font-awesome-icon :icon="['fas', 'exclamation-circle']" style="color:#888; font-size:24px" /></div>
              <div>{{ checkList.length }}名のインフルエンサーを「{{ target_list_name }}」に移動しますか？</div>
            </div>
            <div
              v-if="transferable_titles.length > 0 || blocked_numeric_titles.length > 0"
              class="list-create-box comment-transfer"
            >
              <div class="list-create-name">引き継ぐコメント</div>
              <div class="comment-transfer-help">
                移動元と移動先で同名のコメント列があります。チェックしたタイトルのコメント内容のみ引き継ぎます。
              </div>
              <el-checkbox-group v-if="transferable_titles.length > 0" v-model="selected_transfer_titles">
                <el-checkbox
                  v-for="title in transferable_titles"
                  :key="title"
                  :label="title"
                  class="checkbox-show checkbox-small comment-transfer-item"
                >
                  {{ title }}
                </el-checkbox>
              </el-checkbox-group>
              <div
                v-for="title in blocked_numeric_titles"
                :key="'blocked-' + title"
                class="comment-transfer-blocked"
              >
                {{ numericOnlyTransferBlockedMessage(title) }}
              </div>
            </div>
            <div v-else-if="confirm_columns_loading" class="list-create-box comment-transfer">
              <div class="list-create-name" style="color:#999">コメント列を確認中...</div>
            </div>
            <div class="list-create-footer">
              <div class="flex-space"></div>
              <el-button @click="closeConfirm()">キャンセル</el-button>
              <el-button
                id="ok-button"
                type="primary"
                :disabled="move_loading || confirm_columns_loading"
                @click="moveInfluencer(target_list_id, target_list_name, checkList.length)"
                @keydown.enter="moveInfluencer(target_list_id, target_list_name, checkList.length)"
                @keydown.esc="closeConfirm()"
              >
                <div class="flex-row">
                  OK
                  <div class="loader--mini" v-show="move_loading"></div>
                </div>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadListAPI = root + "/api/list/load_list";
const loadCommentColumnsAPI = root + "/api/list/load_comment_columns";
const moveInfluencerAPI = root + "/api/list/move_influencer";
import {
  getCommentTransferCandidates,
  getNumericOnlyTransferBlockedMessage,
} from "@/utils/listCommentConst";

export default {
  name: "moveListButton",
  props: {
    checkList: { type: Array, default: () => [] },
    sns_type: { type: String, default: "" },
    list_id: { type: [String, Number], default: "" },
    comment_columns: { type: Array, default: () => [] },
  },
  components: {},
  data() {
    return {
      list: [],
      result_count: 0,
      active_list_count: "",
      search_word: "",
      offset: 0,
      infiniteId: +new Date(),
      requestId: +new Date() + 10000,
      loading: false,
      confirm: false,
      move_loading: false,
      target_list_id: "",
      target_list_name: "",
      transferable_titles: [],
      blocked_numeric_titles: [],
      selected_transfer_titles: [],
      confirm_columns_loading: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    permission() {
      return this.$store.state.permission.list;
    },
    activate() {
      return this.$store.state.activate;
    },
  },
  mounted() {
    this.loadList();
    this.addKeyDown();
  },
  methods: {
    infiniteHandler($state) {
      if (this.permission && this.permission.edit) {
        this.loading = true;
        this.axios.cancel(this.requestId);
        this.requestId += 1;
        this.axios
          .get(loadListAPI, {
            requestId: this.requestId,
            params: {
              token: this.token,
              type: "min",
              offset: this.offset,
              search_word: this.search_word,
              sns_type: this.sns_type,
            },
          })
          .then((response) => {
            if (this.offset == 0) {
              this.list = response.data.mylist;
              this.result_count = response.data.result_count;
              this.active_list_count = response.data.active_list_count;
            } else {
              this.list = this.list.concat(response.data.mylist);
            }
            $state.loaded();
            this.offset += 40;
            this.loading = false;
            if (this.result_count <= this.offset) $state.complete();
          });
      }
    },
    loadList() {
      this.list = [];
      this.offset = 0;
      this.result_count = 0;
      this.infiniteId += 1;
    },
    openConfirmModal(list_id, list_name) {
      this.target_list_id = list_id;
      this.target_list_name = list_name;
      this.transferable_titles = [];
      this.blocked_numeric_titles = [];
      this.selected_transfer_titles = [];
      this.confirm = true;
      this.loadTransferableTitles(list_id);
      setTimeout(() => {
        this.focusOK();
      }, 200);
    },
    closeConfirm() {
      this.confirm = false;
      this.transferable_titles = [];
      this.blocked_numeric_titles = [];
      this.selected_transfer_titles = [];
      this.confirm_columns_loading = false;
    },
    numericOnlyTransferBlockedMessage(title) {
      return getNumericOnlyTransferBlockedMessage(title);
    },
    loadTransferableTitles(targetListId) {
      this.confirm_columns_loading = true;
      this.axios
        .get(loadCommentColumnsAPI, {
          params: {
            token: this.token,
            list_id: targetListId,
          },
        })
        .then((response) => {
          if (response.data.status !== "OK") {
            this.transferable_titles = [];
            this.blocked_numeric_titles = [];
            this.selected_transfer_titles = [];
            return;
          }
          const candidates = getCommentTransferCandidates(
            this.comment_columns,
            response.data.comment_columns || []
          );
          this.transferable_titles = candidates.transferable;
          this.blocked_numeric_titles = candidates.blockedNumeric;
          this.selected_transfer_titles = candidates.transferable.slice();
        })
        .catch(() => {
          this.transferable_titles = [];
          this.blocked_numeric_titles = [];
          this.selected_transfer_titles = [];
        })
        .finally(() => {
          this.confirm_columns_loading = false;
        });
    },
    moveInfluencer(id, name, num) {
      this.move_loading = true;
      this.$message({
        type: "info",
        duration: 0,
        offset: 7,
        showClose: true,
        dangerouslyUseHTMLString: true,
        message: 'インフルエンサーを移動中です<div class="loader--mini"></div>',
      });
      var params = new URLSearchParams();
      params.append("list_id_old", this.list_id);
      params.append("list_id_new", id);
      params.append("sns_type", this.sns_type);
      params.append("influencer", JSON.stringify(this.checkList));
      params.append("token", this.token);
      params.append("transfer_comment_titles", JSON.stringify(this.selected_transfer_titles));
      this.axios
        .post(moveInfluencerAPI, params)
        .then(() => {
          this.$emit("loadQuery");
          this.$emit("loadList");
          this.$emit("loadListDetail");
          this.$emit("update:checkList", []);
          this.$message.closeAll();
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: num + "名のインフルエンサーを" + name + "に移動しました",
          });
        })
        .catch(() => {
          this.$message.closeAll();
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "インフルエンサーの移動に失敗しました",
          });
        })
        .finally(() => {
          this.move_loading = false;
          this.closeConfirm();
        });
    },
    openUnpermitted() {
      this.$store.dispatch("openUnpermittedDrawer", true);
    },
    focusOK() {
      const okButton = document.getElementById("ok-button");
      if (okButton) {
        okButton.focus();
      }
    },
    addKeyDown() {
      document.addEventListener("keydown", this.onKeyDown);
    },
    removeKeyDown() {
      document.removeEventListener("keydown", this.onKeyDown);
    },
    onKeyDown(event) {
      if (event.key == "Escape") this.closeConfirm();
    },
  },
  beforeDestroy() {
    this.removeKeyDown();
  },
};
</script>

<style scoped>
.comment-transfer {
  padding: 0 24px 8px;
}
.comment-transfer-help {
  color: #888;
  font-size: 12px;
  line-height: 1.5;
  margin-bottom: 10px;
}
.comment-transfer-item {
  display: block;
  margin: 6px 0;
}
.comment-transfer-blocked {
  color: #888;
  font-size: 12px;
  line-height: 1.5;
  margin: 8px 0;
}
</style>
